/* eslint-disable @typescript-eslint/indent */
import React, { MouseEventHandler } from 'react';
import { ChevronUpIcon, ChevronDownIcon, UserIcon } from '@resortpass/solar-icons';
import { useCookies } from 'react-cookie';
import User from '@customTypes/user';
import cn from '@helpers/className';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  classes?: string;
  isDisabled?: boolean;
  id?: string;
  isLoginMenuOpen?: boolean;
};

export default function ButtonLoginTransparent({
  onClick = () => {},
  classes = '',
  isDisabled = false,
  id = '',
  isLoginMenuOpen = false,
}: Props) {
  const [cookies] = useCookies();
  const user: User = cookies.userInformation;

  return (
    <button
      type="button"
      className={cn({
        'border border-solar-secondary rounded-solar-sm flex justify-center items-center px-spacing-sm py-2 desktop:px-spacing-md':
          true,
        'font-rp-basetica cursor-pointer': true,
        [classes]: !!classes,
        'pointer-events-none opacity-50': isDisabled,
        'pointer-events-auto opacity-100': !isDisabled,
        'bg-solar-button-secondary-hover text-solar-primary': isLoginMenuOpen,
        'text-white': !isLoginMenuOpen,
      })}
      onClick={onClick}
      id={id}
    >
      {user ? (
        <UserIcon width="18px" height="20px" className="login-header" />
      ) : (
        <p className="mr-2 text-sm login-header d:text-base">Login</p>
      )}
      {isLoginMenuOpen ? (
        <ChevronUpIcon className="login-header" fill="#22272A" width="13px" height="13px" />
      ) : (
        <ChevronDownIcon className="login-header" fill="#ffffff" width="13px" height="13px" />
      )}
    </button>
  );
}
